import { textSegments, richTextBlocks } from '../../shared/richText';
import type { TextFormat } from '../../shared/types';

export function RichText({ text, format, interactiveLinks = true }: { text: string; format?: TextFormat[]; interactiveLinks?: boolean }) {
  const inline = (value: string, ranges?: TextFormat[]) => textSegments(value, ranges).map(segment => {
    let content = <>{segment.text}</>;
    if (segment.format?.bold) content = <strong>{content}</strong>;
    if (segment.format?.italic) content = <em>{content}</em>;
    if (segment.format?.underline) content = <u>{content}</u>;
    if (segment.format?.link && !interactiveLinks) content = <u>{content}</u>;
    if (segment.format?.link && interactiveLinks) content = <a href={segment.format.link} target="_blank" rel="noopener noreferrer" onClick={event => event.stopPropagation()}>{content}</a>;
    return content;
  });
  if (!format?.some(range => range.list)) return <span class="rich-text">{inline(text, format)}</span>;
  return <span class="rich-text">{richTextBlocks(text, format).map(block => block.list
    ? <span role="list" class={`rich-text-list ${block.list}`}>{block.lines.map(line => <span role="listitem" class="rich-text-list-item">{inline(line.text, line.format)}</span>)}</span>
    : <span>{block.lines.map((line, index) => <>{index > 0 && '\n'}{inline(line.text, line.format)}</>)}</span>)}</span>;
}
